module.exports = __webpack_public_path__ + "static/media/gameYoupiLogo.a8e36037.png";